import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getQuizDetailRequest, getQuizDetailRequestError, getQuizDetailRequestSuccess } from "../../../slices/teams/members/GetQuizDetailsSlice";
export const GetQuizDetailApi = (id) => async (dispatch) => {


    try {
        dispatch(getQuizDetailRequest());
        axiosInstance({
            method: "GET",
            url: `${endpoints.getQuizDetail}/${id}`,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
              
                return dispatch(getQuizDetailRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getQuizDetailRequestError(_error));
            });
    } catch (error) { }
};
